import { collectScreenInventory } from './screen-inventory';
import { serializeScreenInventory } from './serialize-screen-inventory';

export function currentScreenInventory (): string | null {
    // Required lazily so importing the Leo store does not build the app router.
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { default: router } = require('@/vue-router/router');
    const routeName = String(router.currentRoute.value.name ?? '');
    try {
        const items = collectScreenInventory(routeName);
        if (!items) return null;

        return serializeScreenInventory(items, { routeName, pageTitle: document.title });
    } catch (error) {
        console.error('Leo screen inventory failed', error);

        return null;
    }
}
